import { Tabs } from 'antd'
import JobsList from './JobsList'
import ScheduledJobsContent from './ScheduledJobsContent'
import RescheduleCandidatesList from './RescheduleCandidatesList'
import { ScheduleCreateEventFilters } from './scheduleCreateEventModel'
import { SchedulingJob } from '../scheduleApi'
import { Dayjs } from 'dayjs'

type Props = {
  filters: ScheduleCreateEventFilters
  onEventCreated?: () => void
  selectedDate?: Dayjs
  onJobSelected?: (job: SchedulingJob) => void
}

const JobsContent = ({ filters, onEventCreated, selectedDate, onJobSelected }: Props) => {
  const items = [
    {
      key: '1',
      label: 'Unscheduled',
      children: <JobsList filterUnscheduled={true} filters={filters} onEventCreated={onEventCreated} selectedDate={selectedDate} onJobSelected={onJobSelected} />
    },
    {
      key: '2',
      label: 'Reschedule',
      children: <RescheduleCandidatesList filters={filters} onEventCreated={onEventCreated} selectedDate={selectedDate} />
    },
    {
      key: '3',
      label: 'Scheduled',
      children: <ScheduledJobsContent filters={filters} onEventCreated={onEventCreated} selectedDate={selectedDate} />
    },
    {
      key: '4',
      label: 'All',
      children: <JobsList filters={filters} onEventCreated={onEventCreated} selectedDate={selectedDate} onJobSelected={onJobSelected} />
    },
  ]

  return (
    <Tabs
      defaultActiveKey="1"
      destroyOnHidden
      style={{ backgroundColor: 'white' }}
      tabBarStyle={{ padding: '0 12px', marginBottom: 8 }}
      items={items}
    />
  )
}

export default JobsContent
